import React from 'react';
import { connect } from 'react-redux';

import scrollSpy, { AnchorTarget } from 'jbc-front/components/ScrollSpy';
import ListGroup from 'jbc-front/components/ListGroup';
import Affix from 'jbc-front/components/Affix';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { Edit } from 'jbc-front/components/icons';

import { REDUCER_NAME, deleteEmployee } from 'src/reducers/employees/employees';
import { EMPLOYEE_EDIT, EMPLOYEE_SHOW, EMPLOYEES_LIST } from 'src/constants/EndpointUrls';
import { getItem, setItem } from 'src/reducers/common/itemReducer';
import { setExtras } from 'src/reducers/common/listReducer';
import { REDUCER_NAME as MEMO_REDUCER_NAME } from 'src/reducers/memos/memos';
import MemoList from 'src/features/Memos/MemoList';
import { detailUrlWithQueries } from 'src/utils/Http';
import { NextAndPrevRecordButton, Anchor } from 'src/components';
import { Panel, Item, Headding } from 'src/components/PrimaryPanel';
import { fetchEmployeeDetails } from 'src/reducers/fetchSelectOptions';

import BasicInfoSectionShow from './components/BasicInfoSectionShow';
import BusinessInfoSectionShow from './components/BusinessInfoSectionShow';
import TaxClassificationSectionShow from './components/TaxClassificationSectionShow';
import MaritalStatusSectionShow from './components/MaritalStatusSectionShow';
import SocialSecurityContributionSectionShow from './components/SocialSecurityContributionSectionShow';
import TaxCalculationSectionShow from './components/TaxCalculationSectionShow';
import FamilySupportsSectionShow from './components/FamilySupportsSectionShow';
import PayrollRuleSectionShow from './components/PayrollRuleSectionShow';
import CommutingsSectionShow from './containers/CommutingsSectionShowContainer';
import InhabitantTaxSectionShow from './containers/InhabitantTaxSectionShowContainer';
import BanksSectionShowContainer from './containers/BanksSectionShowContainer';
import PaymentBanksSectionShow from './components/PaymentBanksSectionShow';
import InsuranceSectionShow from './containers/InsuranceSectionShow';
import DeleteEditEmployeeBtn from './components/DeleteEditEmployeeBtn';
// @TODO: Hide Provident Fund for Vietnam - comment out unused import
// https://donuts-vn.atlassian.net/browse/JBC-25
// import EmployeeProvidentFundSectionShow from './components/EmployeeProvidentFundSectionShow';
import EmployeeRemarksShow from './components/EmployeeRemarksShow';
import IncomeTaxAndSSCSectionShow from './components/IncomeTaxAndSSCSectionShow';
import ProbationSettingShow from './components/ProbationSettingShow';
import styles from './ShowEmployee.scss';
import { useTranslation } from 'react-i18next';
import { ProfileImage } from '../../components/ProfileImage';
import { imageType } from '../../utils/Form';
import { User } from 'jbc-front/components/icons';
import { setOptions } from 'src/reducers/selectOptions';
import UnionDuesContributionSectionShow from './components/UnionDuesContributionSectionShow';

const EmployeeSideNavi = ({ current, image }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className="l-flex6-sub">
      <Affix offset={209} className={styles.sideNavi}>
        <ProfileImage name="employeeProfile" image={imageType(image)} defaultImage={<User size={200} />} />
        <ListGroup>
          <Anchor name="BasicInfomation" current={current}>
            {t('features.Employees.showEmployee.basic_information')}
          </Anchor>
          <Anchor name="EmploymentInfomation" current={current}>
            {t('features.Employees.showEmployee.business_information')}
          </Anchor>
          <Anchor name="RemunerationInfomation" current={current}>
            {t('features.Employees.showEmployee.salary')}
          </Anchor>
          <Anchor name="ProbationSetting" current={current}>
            {t('features.Employees.showEmployee.probation_setting')}
          </Anchor>
          {/* <Anchor name="CommutingAllowanceInfomation" current={current}>
            {t('features.Employees.showEmployee.commuting_allowance')}
          </Anchor> */}
          {/* @TODO: Hide Provident Fund for Vietnam */}
          {/* https://donuts-vn.atlassian.net/browse/JBC-25 */}
          {/*
          <Anchor name="ProvidentFundInformation" current={current}>
            {t('features.Employees.components.ProvidentFundSection.provident_fund_setting')}
          </Anchor>
          */}
          <Anchor name="BankInfomation" current={current}>
            {t('features.Employees.showEmployee.bank_account_information')}
          </Anchor>
          <Anchor name="PaymentBankSection" current={current}>
            {t('features.Employees.showEmployee.payment_setting')}
          </Anchor>
          {/* <Anchor name="Dependent" current={current}>
            {t('features.Employees.showEmployee.dependent_information')}
          </Anchor> */}
          {/* <Anchor name="Marital" current={current}>
            {t('features.Employees.showEmployee.spouse_information')}
          </Anchor> */}
          {/* <Anchor name="socialSecurityContribution" current={current}>
            {t('features.Employees.showEmployee.social_security_contribution')}
          </Anchor>  */}
          {/* <Anchor name="TaxCalculation" current={current}>
            {t('features.Employees.showEmployee.tax_calculation')}
          </Anchor> */}
          <Anchor name="SocialSecurityContribution" current={current}>
            {t('features.Employees.showEmployee.social_security_contribution')}
          </Anchor>
          <Anchor name="IncomeTaxAndSSC" current={current}>
            {t('features.Employees.showEmployee.tax_calculation_setting')}
          </Anchor>
          <Anchor name="Remarks" current={current}>
            {t('features.Employees.showEmployee.remarks')}
          </Anchor>
          {/* <Anchor name="PersonalType" current={current}>
            {t('features.Employees.showEmployee.tax_class_information')}
          </Anchor> */}
          {/* <Anchor name="InhabitantTax" current={current}>
            住民税
          </Anchor> */}
          {/* <Anchor name="SocialInsuranceInfomation" current={current}>
            {t('features.Employees.showEmployee.social_insurance')}
          </Anchor> */}
        </ListGroup>
      </Affix>
    </div>
  );
};

const EmployeeMainContent = ({ editUrl, handleDelete, deletable }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className="l-flex6-main">
      <AnchorTarget name="BasicInfomation" />
      <Panel>
        <Headding
          icon={
            <a href={`${editUrl}#BasicInfomation`}>
              <Edit icon={16} />
            </a>
          }
        >
          {t('features.Employees.showEmployee.basic_information')}
        </Headding>
        <Item>
          <BasicInfoSectionShow />
        </Item>
      </Panel>

      <AnchorTarget name="EmploymentInfomation" />
      <Panel>
        <Headding
          icon={
            <a href={`${editUrl}#EmploymentInfomation`}>
              <Edit icon={16} />
            </a>
          }
        >
          {t('features.Employees.showEmployee.business_information')}
        </Headding>
        <Item>
          <BusinessInfoSectionShow />
        </Item>
      </Panel>

      <AnchorTarget name="RemunerationInfomation" />
      <Panel>
        <Headding
          icon={
            <a href={`${editUrl}#RemunerationInfomation`}>
              <Edit icon={16} />
            </a>
          }
        >
          {t('features.Employees.showEmployee.salary')}
        </Headding>
        <Item>
          <PayrollRuleSectionShow />
        </Item>
      </Panel>

      <AnchorTarget name="ProbationSetting" />
      <Panel>
        <Headding
          icon={
            <a href={`${editUrl}#ProbationSetting`}>
              <Edit icon={16} />
            </a>
          }
        >
          {t('features.Employees.showEmployee.probation_setting')}
        </Headding>
        <Item>
          <ProbationSettingShow />
        </Item>
      </Panel>

      {/* @TODO: Hide Provident Fund for Vietnam */}
      {/* https://donuts-vn.atlassian.net/browse/JBC-25 */}
      {/*
      <AnchorTarget name="ProvidentFundInformation" />
      <Panel>
        <Headding
          icon={
            <a href={`${editUrl}#ProvidentFundInformation`}>
              <Edit icon={16} />
            </a>
          }
        >
          {t('features.Employees.components.ProvidentFundSection.provident_fund_setting')}
        </Headding>
        <Item>
          <EmployeeProvidentFundSectionShow />
        </Item>
      </Panel>
      */}

      {/* <AnchorTarget name="CommutingAllowanceInfomation" />
      <Panel>
        <a href={`${editUrl}#CommutingAllowanceInfomation`}>
          <Headding icon={<Edit icon={16} />}>{t('features.Employees.showEmployee.commuting_allowance')}</Headding>
        </a>
        <Item>
          <CommutingsSectionShow />
        </Item>
      </Panel> */}

      <AnchorTarget name="BankInfomation" />
      <Panel>
        <Headding
          icon={
            <a href={`${editUrl}#BankInfomation`}>
              <Edit icon={16} />
            </a>
          }
        >
          {t('features.Employees.showEmployee.bank_account_information')}
        </Headding>
        <Item>
          <BanksSectionShowContainer />
        </Item>
      </Panel>

      <AnchorTarget name="PaymentBankSection" />
      <Panel>
        <Headding
          icon={
            <a href={`${editUrl}#PaymentBankSection`}>
              <Edit icon={16} />
            </a>
          }
        >
          {t('features.Employees.showEmployee.payment_setting')}
        </Headding>
        <Item>
          <PaymentBanksSectionShow />
        </Item>
      </Panel>

      {/*<AnchorTarget name="Dependent" />*/}
      {/*<Panel>*/}
      {/*  <a href={`${editUrl}#Dependent`}>*/}
      {/*    <Headding icon={<Edit icon={16} />}>{t('features.Employees.showEmployee.dependent_information')}</Headding>*/}
      {/*  </a>*/}
      {/*  <Item>*/}
      {/*    <FamilySupportsSectionShow />*/}
      {/*  </Item>*/}
      {/*</Panel>*/}

      {/* <AnchorTarget name="Marital" />
      <Panel>
        <a href={`${editUrl}#Marital`}>
          <Headding icon={<Edit icon={16} />}>{t('features.Employees.showEmployee.spouse_information')}</Headding>
        </a>
        <Item>
          <MaritalStatusSectionShow />
        </Item>
      </Panel> */}
      {/* <AnchorTarget name="socialSecurityContribution" />
      <Panel>
          <Headding icon={<a href={`${editUrl}#socialSecurityContribution`}><Edit icon={16} /></a>}>{t('features.Employees.showEmployee.social_security_contribution')}</Headding>
        <Item>
          <SocialSecurityContributionSectionShow />
        </Item>
      </Panel> */}

      {/* <AnchorTarget name="TaxCalculation" />
      <Panel>
        <Headding icon={<a href={`${editUrl}#TaxCalculation`}><Edit icon={16} /></a>}>{t('features.Employees.showEmployee.tax_calculation')}</Headding>
        <Item>
          <TaxCalculationSectionShow />
        </Item>
      </Panel> */}

      <AnchorTarget name="SocialSecurityContribution" />
      <Panel>
        <Headding
          icon={
            <a href={`${editUrl}#SocialSecurityContributionSection`}>
              <Edit icon={16} />
            </a>
          }
        >
          {t('features.Employees.showEmployee.social_security_contribution')}
        </Headding>
        <Item>
          <SocialSecurityContributionSectionShow />
          <UnionDuesContributionSectionShow />
        </Item>
      </Panel>
      <AnchorTarget name="IncomeTaxAndSSC" />
      <Panel>
        <Headding
          icon={
            <a href={`${editUrl}#IncomeTaxAndSSCSection`}>
              <Edit icon={16} />
            </a>
          }
        >
          {t('features.Employees.showEmployee.tax_calculation_setting')}
        </Headding>
        <Item>
          <IncomeTaxAndSSCSectionShow />
        </Item>
      </Panel>

      <AnchorTarget name="Remarks" />
      <Panel>
        <Headding
          icon={
            <a href={`${editUrl}#Remarks`}>
              <Edit icon={16} />
            </a>
          }
        >
          {t('features.Employees.showEmployee.remarks')}
        </Headding>
        <Item>
          <EmployeeRemarksShow />
        </Item>
      </Panel>

      {/* <AnchorTarget name="PersonalType" />
      <Panel>
        <a href={`${editUrl}#PersonalType`}>
          <Headding>{t('features.Employees.showEmployee.tax_class_information')}</Headding>
        </a>
        <Item>
          <TaxClassificationSectionShow />
        </Item>
      </Panel> */}

      {/* <AnchorTarget name="InhabitantTax" />
      <Panel>
        <a href={`${editUrl}#InhabitantTax`}>
          <Headding icon={<Edit icon={16} />}>{t('features.Employees.showEmployee.inhabitant_tax')}</Headding>
        </a>
        <Item>
          <InhabitantTaxSectionShow />
        </Item>
      </Panel> */}

      {/* <AnchorTarget name="SocialInsuranceInfomation" />
      <Panel>
        <a href={`${editUrl}#SocialInsuranceInfomation`}>
          <Headding>{t('features.Employees.showEmployee.social_insurance')}</Headding>
        </a>
        <Item>
          <InsuranceSectionShow />
        </Item>
      </Panel> */}

      <DeleteEditEmployeeBtn {...{ handleDelete, deletable, editUrl }} />
    </div>
  );
};

const ShowEmployeeView = scrollSpy(
  ({ editUrl, handleDelete, employeeId, employeeName, deletable, nextInfo, prevInfo, current, image }) => {
    const { t, i18n } = useTranslation();
    return (
      <div>
        <div className={`${styles.wrap} l-wrap-xl l-contents-wrap`}>
          <div className="u-mb20">
            <BreadCrumb>
              <BreadCrumb.Item label={t('features.Employees.EmployeeList.employee_list')} path={EMPLOYEES_LIST} />
              <BreadCrumb.Item label={t('features.Employees.showEmployee.employee_information')} />
            </BreadCrumb>
          </div>
          <div className={styles.navi}>
            <NextAndPrevRecordButton {...{ nextInfo, prevInfo, urlFormat: EMPLOYEE_SHOW }} />
          </div>
        </div>

        <div className={styles.head}>
          <div className={styles.memo}>
            <MemoList employeeId={employeeId} size={44} />
          </div>
          <div className={styles.name}>{employeeName}</div>
        </div>

        <div className="l-flex">
          <EmployeeSideNavi {...{ current, image }} />
          <EmployeeMainContent {...{ editUrl, handleDelete, deletable }} />
        </div>
      </div>
    );
  }
);

const ShowEmployee = ({ dispatch, values }) => {
  dispatch(setItem(REDUCER_NAME, values));
  dispatch(setExtras(MEMO_REDUCER_NAME, values.memos));
  dispatch(fetchEmployeeDetails());
  dispatch(
    setOptions({
      client: values.client,
      clientBranch: values.clientBranch,
    })
  );
  const employeeId = values.employee.id;
  const employeeName = values.employee.fullName;
  const image = values.employee.profileImage;
  const { nextInfo, prevInfo, currentQueries, deletable } = values;
  const editUrl = detailUrlWithQueries(employeeId, currentQueries, EMPLOYEE_EDIT);

  return (
    <ShowEmployeeView
      {...{ editUrl, employeeId, employeeName, deletable }}
      handleDelete={() => dispatch(deleteEmployee(employeeId))}
      {...{ nextInfo, prevInfo }}
      {...{ image }}
    />
  );
};

export default connect()(ShowEmployee);
